import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const PartnerResselerServiceContactCard = () => {
	const { t } = useTranslation("admin");

	return (
		<Card>
			<Card.Body>
				<h5>{t("modules.partner.field.resseler_contact.title")}</h5>
				<div className="mt-2 d-flex flex-column">
					<p>
						{t("modules.partner.field.technical_problems.title")}
						<strong>
							{t("modules.partner.field.contact_information.title", { phone: "575675000", internal: 9 })}
						</strong>
						{t("modules.partner.field.internal_number_information.title")}
					</p>
					<p>{t("modules.partner.field.reporting_problems.title")}</p>
				</div>
			</Card.Body>
		</Card>
	);
};

export default PartnerResselerServiceContactCard;
